
import { CardHeader, Input } from "reactstrap";
import styled from "styled-components"

export const StyledCardHeader = styled(CardHeader).attrs(() => ({
    className: "text-white bg-header",
}))`
font-family: "baloo";
font-size: 1.3em;`;


export const StyledInput = styled(Input).attrs(() => ({
    className: "custom-select p-2",
    type: "select",
}))``;


export const StyledLink = styled.a.attrs(() => ({
    target: "_blank",
    rel: "noopener noreferrer"
}))`margin-bottom:"4px`;